// Uma anotação desenhada no padrão do relatório de acompanhamento.
//
// Pedido do Ilton (28/09): os registros eram um bloco corrido, difícil de ler
// "principalmente se a gente tiver algum problema de visão". O padrão que ele
// aprovou é o do relatório: termo em destaque e explicação, um item por linha,
// separação bem marcada entre um item e outro, e o que é alerta em caixa
// vermelha. A anotação é escrita no mesmo Markdown restrito dos relatórios
// especiais e lida pelo mesmo `lerMarkdown` — a tela e o PDF (notaNoPdf)
// desenham igual.
import { lerMarkdown } from '@medicov1/shared';
import { BlocoMd } from './RelatorioEspecial';
import { prepararNota } from './prepararNota';

export function NotaFormatada({ texto }: { texto: string }) {
  return (
    <div className="nota">
      {lerMarkdown(prepararNota(texto)).map((b, i) => <BlocoMd key={i} b={b} />)}
    </div>
  );
}
